import { larc, type LarcPublicStats } from '../lib/api';
import { useApi } from '../hooks/useApi';
import { useTranslation, type TKey } from '../i18n';
import { Sidenote } from '../components/ui';

export default function LarcPage() {
  const { t } = useTranslation();
  const state = useApi(() => larc.stats(), []);
  const s: LarcPublicStats | null = state.status === 'success' ? state.data : null;

  const criteria: TKey[] = ['larc.crit1', 'larc.crit2', 'larc.crit3', 'larc.crit4'];
  const stats: { label: TKey; value: number | undefined; accent?: boolean }[] = [
    { label: 'larc.stApproved', value: s?.approved, accent: true },
    { label: 'larc.stPending', value: s?.larc_pending },
    { label: 'larc.stReviewed', value: s?.ai_reviewed },
    { label: 'larc.stRejected', value: s?.rejected },
    { label: 'larc.stTotal', value: s?.total_questions },
    { label: 'larc.stReports', value: s?.reports_resolved },
  ];

  return (
    <main className="container larc-page">
      <section className="larc-hero">
        <div className="larc-hero__main">
          <div className="kicker">{t('larc.kicker')}</div>
          <h1 className="larc-title">{t('larc.title')}</h1>
          <p className="larc-lead">{t('larc.lead')}</p>
        </div>
        <aside className="larc-hero__aside">
          <Sidenote label={t('larc.missionLabel')} marker="✦">
            <p>{t('larc.missionBody')}</p>
          </Sidenote>
        </aside>
      </section>

      <section className="larc-section">
        <div className="sec-head"><h2>{t('larc.criteriaLabel')}</h2></div>
        <ul className="larc-criteria">
          {criteria.map((c) => (
            <li key={c} className="larc-criteria__item">{t(c)}</li>
          ))}
        </ul>
      </section>

      <section className="larc-section">
        <div className="sec-head">
          <h2>{t('larc.statsLabel')}</h2>
          <span className="meta">{state.status === 'loading' ? t('common.loading') : ''}</span>
        </div>
        <div className="larc-stats">
          {stats.map((st) => (
            <div key={st.label} className={`larc-stat${st.accent ? ' is-accent' : ''}`}>
              <span className="larc-stat__value">{st.value == null ? '—' : st.value.toLocaleString()}</span>
              <span className="larc-stat__label">{t(st.label)}</span>
            </div>
          ))}
        </div>
        <p className="larc-note">{t('larc.note')}</p>
      </section>
    </main>
  );
}
